import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthStorageService, TranslationService, I18nModule } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
// import { ClipboardService } from 'ngx-clipboard';
import { pairwise } from 'rxjs/operators';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { HttpUtilService } from 'src/app/core/services/http-util.service';
import { ToastService } from 'src/app/core/services/toaster.service';
import {CustomProductsService} from '../../custom-landing/custom-products/custom-products.service';
import { BhpTeamModel } from 'src/app/core/model/bhp-team-model';
import { CommonPageBreadcrumbsComponent } from '../../../shared/components/common-page-breadcrumbs/common-page-breadcrumbs.component';
import { NgIf, NgFor, TitleCasePipe } from '@angular/common';
@Component({
    selector: 'app-custom-bhpteam',
    templateUrl: './custom-bhpteam.component.html',
    styleUrls: ['./custom-bhpteam.component.scss'],
    imports: [CommonPageBreadcrumbsComponent, NgIf, NgFor, TitleCasePipe, I18nModule]
})
export class CustomBhpteamComponent implements OnInit {
  contactdetails = false;
  title: any;
  navigationData: string;
  enableLoader = true;
  groupcompanies: any;
  errorMessage: any;
  bhpteamdetails: any;
  userid: any;
  usergroup: any;
  noData = false;
  bhpteam: BhpTeamModel;
  error: string;
  constructor(private translation: TranslationService,
              public toastService: ToastService,
              // private clipboardApi: ClipboardService,
              private userAccountFacade: UserAccountFacade,
              private cd: ChangeDetectorRef, private customProductService: CustomProductsService,
              private customProfileService: CustomProfileService,
              private router: Router
              ) { }
  ngOnInit(): void {
    this.customProductService.getHomeLinkActive(false);
    this.customProductService.scrollToTop();
    this.userAccountFacade.get().subscribe((data: any) => {
      if (data !== undefined) {
        this.userid = data.uid;
        this.cd.detectChanges();
    //    this.usergroup = data.orgUnit.uid;
        this.getBhpTeamData();
        this.customProductService.languageChange$.pipe(pairwise()).subscribe(([previous, current]) => {
          this.enableLoader = true;
          if (current != null) {
            if (previous !== current) {
              this.enableLoader = true;
              if (this.router.url === '/bhpteam') {
                this.getBhpTeamData();
              }
            }
          }
        });
      }
    });

    this.translation.translate('breadcrumb.bhpTeam.pageTitle').subscribe(res => {
      this.title = res;
    });
    this.translation.translate('breadcrumb.bhpTeam.breadcrumb').subscribe(res => {
      this.navigationData = res;
    });
    this.translation.translate('home.toastErrorMessages.copy').subscribe(res => {
      this.error = res;
    });
  }

  getBhpTeamData(): void{

    this.customProfileService.getTeamData(this.usergroup)
    .subscribe(res => {
      if (res) {
        this.bhpteam = undefined;
        this.enableLoader = false;
        this.noData = false;
        if (res.myEmployees) {
          if (res.myEmployees.length === 0){
            this.noData = true;
          }else{
            this.bhpteam = res.myEmployees;
          }
        }else{
         this.noData = true;
        }
        this.cd.detectChanges();
      }
    }, (error) => {                              // Error callback
      this.errorMessage = error;
      this.enableLoader = false;
      // throw error;   //You can also throw the error to a global error handler
    });
  }

  copyText(dataToBeCopied): any {
    // this.clipboardApi.copyFromContent(dataToBeCopied);
    this.toastService.show(this.error);
  }
  navigateToDetails(bhpteamdetails): any {
    this.contactdetails = true;
    this.bhpteamdetails = bhpteamdetails;
  }
}
